<template>
  <div>
    <div :id="id" :style="{ height: height - 32 + 'px' }" />
    <NoDataOverlay :model-value="!(value && value.length)" />
  </div>
</template>
  
  <script>
import * as echarts from "echarts";
import themeJson from "@/assets/echarts-themes/oceanic-balanced.json";
import { v4 as uuidv4 } from "uuid";
import NoDataOverlay from "@/components/atoms/analytics/NoDataOverlay.vue";

export default {
  name: "CampaignImpressionsDistribution",
  components: {
    NoDataOverlay,
  },
  props: {
    id: {
      type: String,
      default: `campaign-impressions-${uuidv4()}`,
    },
    value: {
      type: Array,
      default: () => [],
    },
    height: {
      type: Number,
      default: 300,
    },
  },
  data() {
    return {
      chartInstance: null,
      resizeObserver: null,
    };
  },
  watch: {
    value: {
      handler() {
        this.renderChart();
      },
      deep: true,
    },
  },
  mounted() {
    this.renderChart();
    this.observeResize();
  },
  beforeUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  },

  methods: {
    renderChart() {
      const chartDom = document.getElementById(this.id);
      if (!chartDom) return;

      const chart = echarts.init(chartDom, themeJson.themeName);
      chart.setOption(this.getOptions());

      this.chartInstance = chart;
    },
    observeResize() {
      const chartDom = document.getElementById(this.id);
      if (!chartDom) return;

      this.resizeObserver = new ResizeObserver(() => {
        requestAnimationFrame(() => {
          this.chartInstance?.resize();
        });
      });

      this.resizeObserver.observe(chartDom);
    },
    getOptions() {
      return {
        title: {
          text: "Dog Grooming Services",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          bottom: 0,
          left: "center",
        },
        series: [
          {
            name: "Appointments",
            type: "pie",
            top: "10%",
            radius: "80%",
            bottom: "10%",
            data: [
              { value: 30, name: "Bathing" },
              { value: 20, name: "Haircut" },
              { value: 25, name: "Nail Trim" },
              { value: 15, name: "Ear Cleaning" },
              { value: 10, name: "Teeth Brushing" },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
    },
  },
};
</script>
  
  <style scoped>
.inventory-item-pie-chart {
  width: 100%;
  font-family: Roboto, sans-serif;
}
</style>
  